module.exports = __webpack_public_path__ + "img/jitong.e41ab6f1.jpg";